import { searchBox } from 'instantsearch.js/es/widgets'

/**
 * Load the searchBox widgets.
 *
 * @param {Element} mainContainer The main search container.
 * @returns {Array} The stats widgets.
 */
export default function searchBoxWidgets( mainContainer ) {
  const widgets = []

  Array.from( mainContainer.querySelectorAll( '.js-instant-search-search-box' ) ).forEach(
    element => {
      widgets.push(
        searchBox({
          container: element,
          placeholder: element.dataset.placeholderText,
          autofocus: true,
          showSubmit: false,
          showReset: false,
          showLoadingIndicator: false,
        })
      )
    })

  return widgets
}
